import { render, staticRenderFns } from "./ClassificationTab.vue?vue&type=template&id=463cb506"
import script from "./ClassificationTab.js?vue&type=script&lang=js&external"
export * from "./ClassificationTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports